export default __webpack_public_path__ + "static/media/2246.4ae4d7a1.png";